module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/Button/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/Button/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/Button/Button.palette.ts
var palette = {
  set: 'carvana',
  primary: {
    bg: {
      color: 'blue',
      normal: 'primary',
      hover: 'hover'
    },
    text: {
      color: 'white',
      normal: 'primary',
      hover: 'primary'
    }
  },
  secondary: {
    bg: {
      color: 'yellow',
      normal: 'primary',
      hover: 'hover'
    },
    text: {
      color: 'white',
      normal: 'primary',
      hover: 'primary'
    }
  },
  light: {
    bg: {
      color: 'white',
      normal: 'primary',
      hover: 'primary'
    },
    text: {
      color: 'blue',
      normal: 'primary',
      hover: 'hover'
    },
    ghostText: {
      color: 'gray',
      hover: 'dark'
    }
  },
  disabled: {
    bg: {
      color: 'gray',
      normal: 'light'
    },
    text: {
      color: 'white',
      normal: 'primary'
    }
  }
};
/* harmony default export */ var Button_palette = (palette);
// CONCATENATED MODULE: ./src/Button/Button.styles.tsx



var Button_styles_presetColors = function presetColors(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      theme = _ref.theme,
      _ref$ghost = _ref.ghost,
      ghost = _ref$ghost === void 0 ? 'false' : _ref$ghost;
  var _palette$color = Button_palette[color],
      bg = _palette$color.bg,
      text = _palette$color.text;
  var set = Button_palette.set;
  var textColor = theme[set][text.color];
  var bgColor = theme[set][bg.color];
  var ghostText = Button_palette[color].ghostText || text;
  return ghost ? "\n    background: transparent;\n    color: " + bgColor[bg.normal] + ";\n    border-color: " + bgColor[bg.normal] + ";\n\n    &:hover {\n      background: " + bgColor[bg.hover] + ";\n      color: " + theme[set][ghostText.color][ghostText.hover] + ";\n      border-color: transparent;\n    }\n  " : "\n    background: " + bgColor[bg.normal] + ";\n    color: " + textColor[text.normal] + ";\n\n    &:hover {\n      background: " + bgColor[bg.hover] + ";\n      color: " + textColor[text.hover] + ";\n    }\n  ";
};

var Button_styles_disabledStyles = function disabledStyles(_ref2) {
  var theme = _ref2.theme;
  var set = Button_palette.set,
      _palette$disabled = Button_palette.disabled,
      text = _palette$disabled.text,
      bg = _palette$disabled.bg;
  return "\n    background: " + theme[set][bg.color][bg.normal] + ";\n    color: " + theme[set][text.color][text.normal] + ";\n    pointer-events: none;\n    cursor: default;\n    border-color: transparent;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);\n  ";
};

var smallStyles = "\n  font-size: 12px;\n  min-height: 39px;\n";
var defaultButtonStyles = "\n  width: 251px;\n  font-size: 14px;\n  line-height: 20px;\n  box-sizing: border-box;\n  min-height: 56px;\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  font-weight: bold;\n  text-transform: uppercase;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  margin: 0;\n  border: 1px solid transparent;\n  padding: 0 10px;\n  outline: none;\n  position: relative;\n  user-select: none;\n  align-items: center;\n  vertical-align: middle;\n  justify-content: center;\n  text-decoration: none;\n  appearance: none;\n  border-radius: 3px;\n  font-family: 'Brandon Text';\n  display: block;\n";
var conditionalStyles = function conditionalStyles(props) {
  return [props.disabled && Button_styles_disabledStyles(props), props.small && smallStyles].filter(Boolean).join('');
};
var DefaultButton = external_styled_components_default.a.button.withConfig({
  displayName: "DefaultButton",
  componentId: "sc-1ykg7w6-0"
})(["", " ", " ", ""], defaultButtonStyles, Button_styles_presetColors, conditionalStyles);
// CONCATENATED MODULE: ./src/Button/Button.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var defaultProps = {
  small: false,
  color: 'primary',
  ghost: false,
  disabled: false,
  className: '',
  testId: 'Button',
  type: 'button'
};

var Button_Button = function Button(_ref) {
  var small = _ref.small,
      color = _ref.color,
      ghost = _ref.ghost,
      disabled = _ref.disabled,
      className = _ref.className,
      testId = _ref.testId,
      children = _ref.children,
      onClick = _ref.onClick,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["small", "color", "ghost", "disabled", "className", "testId", "children", "onClick", "type"]);

  return /*#__PURE__*/external_react_default.a.createElement(DefaultButton, _extends({
    small: small,
    color: color,
    ghost: ghost,
    disabled: disabled,
    "data-cv-test": testId,
    type: type,
    className: className,
    onClick: onClick
  }, props), children);
};

Button_Button.defaultProps = defaultProps;
/* harmony default export */ var src_Button_Button = (Button_Button);
// CONCATENATED MODULE: ./src/Button/index.ts
/* concated harmony reexport defaultButtonStyles */__webpack_require__.d(__webpack_exports__, "defaultButtonStyles", function() { return defaultButtonStyles; });



/* harmony default export */ var src_Button = __webpack_exports__["default"] = (src_Button_Button);

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=Button.js.map